import _, { add, set } from "lodash";
import React, { useState, useRef, useEffect } from "react";
import AddPlaylistModal from "./AddPlaylistModal";
import { makeRequest } from "../../utils/request";
import { mutate } from "swr";
import useOnClickOutside from "../../hooks/useOnClickOutside";
import { pushDatatoAdobeLayer } from "../../analytics/pmiAdobeLog";
import { getAdobeAnalyticsEventObject, getAdobeAnalyticsCustomLinkObj, getAdobeAnalyticsPlayListObj } from '../../analytics/analyticsObject';
import { getUrlWithoutPathname } from "../../utils/utility";
const PlaylistModal = ({ isAuthenticated, post, playlists, children }) => {
  const [showModal, setShowModal] = useState(false);
  const [opened, setOpened] = useState(false);
  const [contentItem, setContentItem] = useState(null);
  const ref = useRef();
  const [playlistItems, setPlayListItems] = useState(playlists);
  let [addplaylistItems, setAddPlayListItems] = useState([])
  const [isCheckedPlayList, setisCheckedPlayList] = useState('');
  const [modalOpen, setModalOpen] = useState(false);
  const [onClickOutside, setonClickOutside] = useState(false);

  useOnClickOutside(ref, () => setOpened(false), 'playList' , () => setonClickOutside(true), opened, modalOpen);
  useEffect(() => {
    if (addplaylistItems.length > 0 && isCheckedPlayList === -1) {
      if (!opened && modalOpen && onClickOutside) {
        let industryArray = (post.industry && post.industry.length > 0) ? (post.industry).map(item => (item.name)) : ''
        let topicsArray = (post.topic && post.topic.length > 0) ? (post.topic).map(item => ',' + item.name) : ''
        let subTopicsArray = (post.subTopic && post.subTopic.length > 0) ? (post.subTopic).map(item => ',' + item.name) : ''
        let tagsArray = industryArray + topicsArray + subTopicsArray;
        tagsArray = tagsArray.replace(/^,/, '');
        tagsArray = tagsArray.replace(/,+/g, ',');
        let contEventObj = getAdobeAnalyticsEventObject(
          "card-cont-click",
          "card-cont-click",
          "cont-click"

        );

        let customEventObj = getAdobeAnalyticsEventObject("linkClick", "linkClick");
        let customLObj = getAdobeAnalyticsCustomLinkObj(
          'Playlist : saved',
          'playlist',
          getUrlWithoutPathname()
        );
        let contObj = getAdobeAnalyticsPlayListObj({
          cont: {
            contClick: "saved",
            contID: post.contentKey,
            contLang: post.language,
            contName: post.title,
            contTags: tagsArray,
            contTopic: post.topic[0].name,
            contSource: post.source,
            contIndustry: industryArray && industryArray.length > 0 ? industryArray[0] : 'not available',
          }
        });
        pushDatatoAdobeLayer({
          onContClickData: { ...contEventObj, ...contObj },
          customLinkData: { ...customEventObj, ...customLObj },
          pageData: false,
          adobePushTracking: false,
        });
        setModalOpen(false);
        setonClickOutside(false)
        setAddPlayListItems([])
        // isCheckedPlayList("")
      }
    }
  }, [modalOpen, onClickOutside,isCheckedPlayList])
  const toggleOpen = () => {
    setModalOpen(false);
    setonClickOutside(false)
    // modalOpen = true;
    setModalOpen(true)
    if (isAuthenticated) {
      getUpdatePlaylists();
    }
  };
  const getUpdatePlaylists = async () => {
    const updatePlaylists = await makeRequest("get", "/api/playlist/getplaylistwithlikes");
    setPlayListItems(updatePlaylists.playlists);
    setOpened(!opened);
  };
  const handleClickItem = async item => {
    const contentKeys = [...item.contentKeys];

    const index = contentKeys.indexOf(post.contentKey);
    setisCheckedPlayList(index)
    if (index === -1) {
      contentKeys.push(post.contentKey);
    } else {
      contentKeys.splice(index, 1);
    }
    const playlist = {
      ...item,
      contentKeys,
    };
    addplaylistItems = addplaylistItems.concat(item);
    setAddPlayListItems(addplaylistItems)
    const newPlaylist = await makeRequest("post", "/api/playlist", playlist);
    const newPlaylists = JSON.parse(JSON.stringify(playlistItems));
    const currentPlaylist = newPlaylists.findIndex(
      x => x.id === newPlaylist.id
    );
    newPlaylists[currentPlaylist] = newPlaylist;
    setPlayListItems(newPlaylists);
    await mutate("/api/playlist/getplaylistwithlikes", newPlaylists);
    //adobe update
  };

  const checked = contentKeys => {
    if (!contentKeys) {

      return false;
    }

    return !(contentKeys.indexOf(post.contentKey) === -1);
  };

  const truncate = title => {
    return _.truncate(title, {
      length: 15,
      separator: " "
    });
  };

  const openAddPlaylist = () => {
    setOpened(false);
    setContentItem(post.contentKey);
    setShowModal(true);
  };

  return (
    <div
      ref={ref}
      className={`playlist relative inline-block ${opened ? "open" : ""}`}
    >
      {showModal && (
        <AddPlaylistModal
          closeModal={() => setShowModal(false)}
          contentItem={contentItem}
          playlists={playlistItems}
          updatePlaylist={setPlayListItems}
          post={post}
        />
      )}
      <button onClick={() => toggleOpen()}>{children}</button>
      <div className="playlist-content block absolute bg-white pt-2 z-30 rounded-sm shadow-md">
        <div
          className="overflow-auto"
          style={{ maxHeight: "200px", maxWidth: "250px" }}
        >
          {playlistItems &&
            playlistItems.map(item => (
              <div adoberegion='create-playlist'
                className="flex flex-no-wrap justify-start items-center cursor-pointer py-2 px-4 hover:bg-gray-100"
                key={item.id}
                onClick={() => handleClickItem(item)}
              >
                <div className="mr-3 text-md">
                  {checked(item.contentKeys) ? (
                    <span>
                      <i className="far fa-check-square text-blue-400"></i>
                    </span>
                  ) : (
                    <span>
                      <i className="far fa-square"></i>
                    </span>
                  )}
                </div>
                <div className="text-sm">{truncate(item.title)}</div>
              </div>
            ))}
        </div>
        <div
          className="flex flex-no-wrap justify-start items-center shadow-md border-t cursor-pointer py-2 px-4 hover:bg-gray-100"
          onClick={() => openAddPlaylist()}
        >
          <span className="text-sm">Create Playlist</span>
        </div>
      </div>
    </div>
  );
};

export default PlaylistModal;
